export const catalogPageSize = 24;
export const maximumCatalogPage = 1000;
export function readCatalogPage(value: unknown): number {
  const text = typeof value === "number" ? String(value) : typeof value === "string" ? value : "";
  return /^[1-9][0-9]{0,3}$/.test(text) && Number(text) <= maximumCatalogPage ? Number(text) : 1;
}
export function paginationItems(page: number, pagesTotal: number): (number | "ellipsis-left" | "ellipsis-right")[] {
  const last = Math.min(maximumCatalogPage, Math.max(1, Math.floor(pagesTotal)));
  const current = Math.min(last, readCatalogPage(page));
  const numbers = [...new Set([1, last, current - 2, current - 1, current, current + 1, current + 2])].filter(value => value >= 1 && value <= last).sort((a, b) => a - b);
  const result: (number | "ellipsis-left" | "ellipsis-right")[] = [];
  for (const [index, number] of numbers.entries()) {
    const previous = numbers[index - 1];
    if (previous && number - previous === 2) result.push(previous + 1);
    else if (previous && number - previous > 2) result.push(number < current ? "ellipsis-left" : "ellipsis-right");
    result.push(number);
  }
  return result;
}
export function normalizeCatalogPagination(value: unknown, requestedPage: number) {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("Risultati della ricerca non verificabili.");
  const data = value as Record<string, unknown>;
  if (!Number.isSafeInteger(data.total) || Number(data.total) < 0 || data.page !== requestedPage || data.pageSize !== catalogPageSize || !Number.isSafeInteger(data.pagesTotal) || data.pagesTotal !== Math.ceil(Number(data.total) / catalogPageSize)) throw new Error("La numerazione dei risultati non è verificabile. Riprova.");
  return { page: requestedPage, pageSize: catalogPageSize, total: Number(data.total), pagesTotal: Math.min(maximumCatalogPage, Number(data.pagesTotal)) };
}
